import angular from 'angular';

export default angular
	.module('ui.cian.utils.validateInteger', [])
	.directive('cianUtilsValidateInteger', () => {
		return {
			restrict: 'A',
			require: 'ngModel',
			link: (scope, element, attrs, ngModel) => {
				const checkInteger = input => {
					let isInt = true; // set true first

					if (input) {
						const numNumber = Number(input);
						const numInteger = parseInt(numNumber, 10);
						isInt = numInteger === numNumber;
					}

					return isInt;
				};
				ngModel.$validators.integer = checkInteger;
			}
		};
	})
	.name;
